var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('account-balance',{attrs:{"client-type":_vm.usedClientType,"client-id":_vm.actingClientId,"is-own":_vm.isOwn}})}
var staticRenderFns = []

export { render, staticRenderFns }